module.exports = __webpack_public_path__ + "media/images/flags/64/Niger-ba2884ec54c400131331f43dd928538a.png";